import { useFeatureValue } from '@shared/core/featureFlags';
import { CatalogDepartmentDictionaryEntry } from '../../state/Catalog';
import { ProductUniversalSearchSourceLimit } from '@graphql/generated';

type UniversalSearchFeatureConfig = {
  universalCatalogSearchMode: UniversalCatalogSearchMode;
  universalCatalogMeshSourceLimits?: ProductUniversalSearchSourceLimit[];
  loading: boolean;
};

export enum UniversalCatalogSearchMode {
  /**
   * The universal catalog search is disabled
   */
  disabled = 'disabled',

  /**
   * External products are meshed with catalog items
   */
  meshedProductGrid = 'meshedProductGrid',

  /**
   * External products are displayed separately
   */
  separatedProductGrid = 'separatedProductGrid'
}

export const useUniversalSearchFeature = (): UniversalSearchFeatureConfig => {
  const { value: universalCatalogSearchEnabled, loading } = useFeatureValue('universalCatalogSearchEnabled');
  const { value: universalCatalogMeshExperimentVariant, payload: universalCatalogMeshSourceLimits } = useFeatureValue('universalCatalogMeshExperiment');

  const isUniversalCatalogMeshEnabled = universalCatalogMeshExperimentVariant || universalCatalogMeshSourceLimits;
  let universalCatalogSearchMode: UniversalCatalogSearchMode;
  if (universalCatalogSearchEnabled !== 'on') {
    universalCatalogSearchMode = UniversalCatalogSearchMode.disabled;
  } else if (!isUniversalCatalogMeshEnabled || universalCatalogMeshExperimentVariant === 'control') {
    universalCatalogSearchMode = UniversalCatalogSearchMode.separatedProductGrid;
  } else {
    universalCatalogSearchMode = UniversalCatalogSearchMode.meshedProductGrid;
  }

  return {
    universalCatalogSearchMode,
    universalCatalogMeshSourceLimits,
    loading
  } as UniversalSearchFeatureConfig;
};

export const getUniversalSearchTermFromCategory = (category: Maybe<CatalogDepartmentDictionaryEntry>) => {
  if (category && category.lineageCsp?.length > 1) {
    if (category.lineageCsp[1]?.title === 'Cash Funds') {
      return undefined;
    }

    const searchTermComponents = category.lineageCsp.slice(1).map(cat => cat.title);
    searchTermComponents.push(category.title);

    const searchTerm = searchTermComponents.join(' ');

    return searchTerm;
  }

  return undefined;
};
